export const CartCommon = {
 CartCommon: {
    label: {
    name: 'Name',
    number: 'Number',
    status: 'Status',
    requestedDeliveryDate: 'Requested Delivery Date',
    customerPO: 'Customer P.O.',
    jobNameNumber: 'Job Name / Number',
    shipComplete: 'Ship Complete',
    headerNotes: 'Special Instruction',
    referenceCart: 'Reference Draft Order',
    createdBy: 'Created By',
    createdDate: 'Created date',
    lastUpdatedDate: 'Last Updated Date',
    submitForApproval: 'Submit For Approval',
    checkout: 'Checkout',
    totalItems: 'Total Items:',
    totalQuantity: 'Total Quantity:',
    totalPrice: 'Total Price:',
    itemDetails: 'Item Details',
    productDetails: 'Product Details',
    plant: 'Plant',
    requestedShipDate: 'Requested Ship Date',
    listPrice: 'List Price',
    netPrice: 'Net Price',
    quantity: 'Quantity',
    total: 'Total',
    priceAdjustment: 'Price Adjustment',
    quoteReference: 'Quote Reference',
    uom: 'UOM',
    moq: 'MOQ',
    actions: 'Actions',
    cart: 'Cart',
    downloadPDF: 'Download PDF',
    createdOn: 'Created On',
    saveUpdatedCart: 'Save Updated Cart',
    lineNo: 'Line No.',
    update: 'Update Cart',
    atgDivision: 'ATG Division',
    customerName: 'Account Name',
    customerAccount: 'Customer Account',
    specialInstructions: 'Special Instructions',
    productAvailability: 'Inventory on Hand / Lead Time',
    customerMaterialNumber: 'Customer Material Number',
    promoCode: 'Promo Code',
    salesDeal:  'Sales Deal',
    quote: 'Quote Number',
    costCentre: 'Cost Centre',
    storeNumber: 'Store Number',
    deliveryUnitAdjusted: 'The order quantity needs to be multiplier of delivery {{ unit }} qty',
    moqAdjusted: 'The order quantity must be greater than or equal to the minimum order quantity.',
  },
  reorderConfirmDialog: {
    title: 'Active Draft Order',
    body: 'You currently have active draft order. You are about to reorder items from historical Order. How would you like to proceed?',
    continueWithActive: 'Continue with Active Draft Order',
    createNew: 'Create New Draft Order',
  },
  validation: {
    duplicatePONumber: 'Duplicate PO Number Detected',
    purchaseOrderNumber: {
      maxlength: 'Customer PO cannot exceed 25 characters',
      pattern: 'Customer PO cannot contain special characters',
    },
    promoCode: {
      maxlength: 'Promo Code cannot exceed 40 characters',
      pattern: 'Promo Code must contain alpha-numeric and special characters only',
    },
    salesDeal: {
      maxlength: 'Sales Deal cannot exceed 40 characters',
      pattern: 'Sales Deal must contain alpha-numeric and special characters only',
    },
    quote: {
      maxlength: 'Quote Number cannot exceed 9 digits',
      pattern: 'Quote Number must contain numeric characters only (0-9)',
    },
  },
  createMessage: {
    success: 'Draft order has been created successfully.',
    error: 'Error occurred while creating draft order.',
  },
  copyMessage: {
    success: 'Draft order has been copied successfully.',
    error: 'Error occurred while copying draft order.',
  },
  updateMessage: {
    success: 'Draft order has been updated successfully.',
    error: 'Error occurred while updating draft order.',
  },
  deleteMessage: {
    success: 'Draft order has been deleted successfully.',
    error: 'Error occurred while deleting draft order.',
  },
  invalidQtyMessage: {
    entryMessage: 'Please enter valid quantity (Multiple of MOQs) for this item',
    globalMessage: 'Please enter valid quantity (Multiple of MOQs) for Line Nos {{ linenos }}',
  },
  commentMessage: {
    isGenericGlobalMessage:
      'For Product(s): {{ linenos }}, please fill in required field arc worksheet, drawing # or comments',
    isSinkPatternGlobalMessage:
      'For Product(s): {{ linenos }}, you must choose the drill pattern requirement from the drop down table.',
  },
  referenceRemovedMessage: 'Quote reference has been updated successfully.',
  messages: {
    discontinuedCannotOrder: 'This item {{ code }} is discontinued and cannot be ordered.',
    partialReorderSkippedItems: 'One or more items from this historical order are no longer available in the catalog and were skipped. Please review your cart to verify the loaded lines.',
  },
  toolTip: {
    promoCode: 'Promotional pricing will be reflected on your order confirmation after order processing.',
    quote: 'Quote (SPR) pricing is not displayed on ATG Connect.  Any approved quote pricing will be reflected on your order confirmation.',
  },
 }
};
export const cartSearchForm = {
  label: {
    draftOrderName: 'Name',
    accountNumber: 'Account Number',
    accountName: 'Account Name',
    customerPO: 'Customer P.O.',
    jobNameNumber: 'Job Name / Number',
    status: 'Status',
    draftOrderNumber: 'Number',
  },
};
export const cartResult = {
  header: {
    draftOrderNumber: 'Number',
    draftOrderName: 'Name',
    createdBy: 'Created By',
    creationDate: 'Creation Date',
    createdOn: 'Created On',
    accountNo: 'Account No.',
    accountName: 'Account Name',
    customerPO: 'Customer P.O.',
    jobNameNumber: 'Job Name / Number',
    status: 'Status',
    total: 'Total',
    actions: 'Actions',
    job: 'Job',
    updateBy: 'Update By',
  },
  nodataMsg: 'Draft orders will appear here once they are created and saved.',
  showMore: 'Show More',
};
export const addToCartMessage = {
  success: 'Product(s) are added to  draft order successfully.',
  failure: 'Product(s) are not added to draft order successfully.',
};
